export default __webpack_public_path__ + "static/media/prisca (2).24229345.jpg";